import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { DirectoryFaxNumberSearchDto } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";

export class DirectoryFaxNumber {
    public id: string;
    public number: string;
    public countryId: string;
    public description: string;

    public isObsoleteFaxNumberLink?: boolean;

    public constructor(init?: Partial<DirectoryFaxNumber>) {
        Object.assign(this, init);

        if (!this.id)
            this.id = GuidHelper.NewGuid();
    }

    public static fromSearchDto(dto: DirectoryFaxNumberSearchDto): DirectoryFaxNumber {
        return new DirectoryFaxNumber(dto);
    }

    public isDuplicate(faxNumbers: DirectoryFaxNumber[]): boolean {
        return faxNumbers.any(p => p.number === this.number && p.countryId === this.countryId);
    }
}
